import { JwtAxios } from '@/packaging';

export const errorReportAPI = {
  // 오류 보고 / 관리자 문의 접수 (백엔드 ErrorReport/Submit, AllowAnonymous)
  // payload: { category, errorType, program, title, userId, problemUrl, message, detail }
  // - category: 'ERROR'(오류신고) | 'INQUIRY'(관리자문의). 비우면 ERROR
  // - userId 는 로그인 상태면 서버가 토큰 값으로 덮어쓴다.
  async submit(payload) {
    const res = await JwtAxios.post('/ErrorReport/Submit', payload);
    return res;
  },
  // 내가 접수한 오류신고/문의 목록 (답변 포함)
  // body: { category, onlyReplied, page, limit }
  async myList(body) {
    const res = await JwtAxios.post('/ErrorReport/MyList', body ?? {});
    return res;
  },
  // 확인하지 않은 답변 건수 (헤더 알림 뱃지용)
  async myUnreadCount() {
    const res = await JwtAxios.get('/ErrorReport/MyUnreadCount');
    return res;
  },
  // 답변 읽음 처리 body: { idxList: [], allRead: false }
  async markRead(body) {
    const res = await JwtAxios.post('/ErrorReport/MarkRead', body ?? {});
    return res;
  }
};
